import {
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Foir from "../Customer/Foir";

const Credit = ({cid, lid, foir_data}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  return (
    <Col xs="6" sm="4" md="3">
      <Card className="card-stats mb-4">
        <CardBody>
          <Row>
            <div className="col">
              <CardTitle
                tag="h5"
                className="text-uppercase text-muted mb-0"
              >
                FOIR
              </CardTitle>
             <span
              className="h2 font-weight-bold mb-0 text-success clickable"
              style={{ cursor: "pointer" }}
              onClick={toggleModal}
            >
              DBR ({foir_data?.dbr}%)
            </span>
            </div>
          </Row>
        </CardBody>
      </Card>
        <Modal isOpen={modalOpen} toggle={toggleModal} size="lg" style={{ maxWidth: '90%' }} className="w-100" >
       
        <ModalBody>
          <Foir/>
          
        </ModalBody>
      </Modal>
    </Col>
  );
};

export default Credit;
